import React from 'react';
import { HomeView } from './views';
import { Provider } from 'react-redux';
import store from './store/store';
import { ConfigProvider } from './@turing/theme';

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <HomeView />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
